<lcp-header *ngIf="fields" [isInverted]="!!fields['bannerColor']"></lcp-header>

<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <section [ngClass]="[
        'lcp-section', 
        !!fields['bannerColor'] ? 'is-banner' : '',
        fields['bannerColor'] ? 'is-background-' + fields['bannerColor'] : ''
      ]">
      <div class="lcp-section-content">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm">
            {{ fields['title'] }}
          </h1>
        </div>
      </div>
    </section>

    <!-- <section>
      <div class="lcp-section-content">
        <div class="display-flex">
          <lcp-rich-text
            class="lcp-subheading flex-50-not-sm margin-bottom-80"
            [document]="fields['subheading']">
          </lcp-rich-text>
        </div>
      </div>
    </section> -->

    <section *ngFor="let section of fields['sections']">
      <div [ngClass]="['lcp-section-content', 'blocks-container']"> 
        <!-- <div *ngFor="let section of fields['sections']" -->

        <div class="display-flex" *ngIf="fields['subheading']">
          <lcp-rich-text
            class="lcp-subheading flex-50-not-sm"
            [document]="fields['subheading']">
          </lcp-rich-text>
        </div>

        <div *ngFor="let block of section.fields['items']"
          [ngClass]="['lcp-content-block', lcpHelper.blockClass(block)]"> 
          <!-- !!block.fields['slug'] ? block.fields['slug'] : null]"> -->

          <lcp-content-block
            [block]="block">
          </lcp-content-block>

        </div>
      </div>
    </section>
  </ng-container>
</div>
